//region header
//--------------------------------------------------------------------------------------------------
//
//  Description: The page to display when we get an unknown error.
//
//  Copyright:    © 2025 Idox Software Limited.
//
//--------------------------------------------------------------------------------------------------
//
//  Modification History:
//
//  Version Date     Modifier             Issue# Description
//region Version 1.0.7.0
//    001   04.09.25 Sean Flook       IMANN-1812 Initial version.
//endregion Version 1.0.7.0
//
//--------------------------------------------------------------------------------------------------
//endregion header

import React from "react";
import { useRouteError } from "react-router";

export function UnknownErrorBoundary() {
  const error = useRouteError();

  return (
    <div style={{ padding: "2rem", textAlign: "center" }}>
      <h1>Something went wrong</h1>
      <p>We encountered an unexpected error.</p>
      {error && (
        <div style={{ marginTop: "1rem", color: "red" }}>
          <p>
            <strong>Error:</strong> {error.statusText || error.message}
          </p>
          {process.env.NODE_ENV === "development" && error.stack && (
            <pre style={{ textAlign: "left", marginTop: "1rem", overflowX: "auto" }}>{error.stack}</pre>
          )}
        </div>
      )}
    </div>
  );
}

export default UnknownErrorBoundary;
